import type React from 'react';
import { BeatLoader } from 'react-spinners';

type LengthType = number | string;

type SpinnerProps = {
    size?: LengthType;
    margin?: LengthType;
    color?: string;
    loading?: boolean;
    className?: string;
    speedMultiplier?: number;
};

const Spinner: React.FC<SpinnerProps> = ({
    size = 15,
    margin = 2,
    color = '#2970ff',
    loading = true,
    speedMultiplier = 1,
    className,
}) => {
    return (
        <BeatLoader
            size={size}
            margin={margin}
            color={color}
            loading={loading}
            speedMultiplier={speedMultiplier}
            className={className}
        />
    );
};

export default Spinner;
